import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from "@angular/core";

import { QuestionGroupAttachmentModalComponent as GRAttachmentModal } from "./question-group-attachment-modal/question-group-attachment-modal.component";
import { QuestionGroupFormModalComponent as QGFormModal } from "./question-group-form-modal/question-group-form-modal.component";
import { ConfirmComponent } from "../../shared/component/confirm/confirm.component";
import { MessageComponent } from "../../shared/component/message/message.component";
import { QuestionGroupModel } from "../../shared/model/question-group.model";
import { QuestionComponent } from "./question/question.component";
import { copyQuestionGroup } from "../utils";

import * as _ from "lodash";

@Component({
  styles: [""],
  selector: "app-question-group",
  templateUrl: "./question-group.component.html",
})
export class QuestionGroupComponent implements OnInit {
  // Esse arquivo for refatorado, para melhor visualização, 
  // mas ele foi criado dessa forma por outro desenvolvedor

  @Input() question_groups: QuestionGroupModel[];
  @Input() isEndpointEnabled: number | boolean;
  @Output() saveGroup = new EventEmitter();

  @ViewChild(GRAttachmentModal) questionGroupAttachmentModal: GRAttachmentModal;
  @ViewChild(QGFormModal) questionGroupFormModal: QGFormModal;

  @ViewChild(QuestionComponent) questionComponent: QuestionComponent;
  @ViewChild(MessageComponent) message: MessageComponent;
  @ViewChild(ConfirmComponent) confirm: ConfirmComponent;

  groupIndex: number = null;
  activeQuestionGroup;
  previousGroup;
  displayAttach;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {}

  getInstance = (obj: any) => JSON.parse(JSON.stringify(obj));

  // Safe - Fixed Group Item Order
  onCopyQuestionGroup(questionGroup) {
    const copy = copyQuestionGroup(questionGroup, this.question_groups, true);
    // const unlinked = this.getInstance(copy); // not required

		copy.item_order = this.question_groups.length + 1;

    this.question_groups.push(copy);

    this.orderQuestionGroupNew(copy);
  };

  // Refatorado
  saveQuestionGroup(e: QuestionGroupModel) {
    // Somar o peso atual de todos os grupos de perguntas
    let weightSum = this.question_groups.reduce((acc, curr) => acc + curr.weight, 0);
  
    // Adicionar o peso da nova pergunta ao cálculo
    weightSum += e.weight;
    weightSum = Math.round(weightSum * 100) / 100;
  
    // Verificar se há um grupo selecionado e subtrair seu peso do cálculo
    if ((this.groupIndex || this.groupIndex == 0) && this.groupIndex > -1 && this.groupIndex < this.question_groups.length) {
      weightSum -= this.question_groups[this.groupIndex].weight;
    } else {
      console.warn('invalid groupIndex', this.groupIndex);
    }
  
    // Verificar se a soma total de pesos não ultrapassa 100
    if (!this.weightSumGreaterThan100(weightSum)) {
      this.orderQuestionGroupNew(e);
    }

    // Resetar o índice do grupo selecionado e fechar o modal
    this.groupIndex = null;
    this.questionGroupFormModal.display = false;
  }

  // Refatorado
  getWeightSum(questionGroup) {
    let message = '';

    // Validar se 'questionGroup' é um objeto válido e se 'questions' é um array válido
    if (!Array.isArray(questionGroup.questions)) {
      message = "'questions' não é um array válido.";
      this.message.error(message);
      console.error(message);

      // nullSafetly validation
      return 0;
    }

    // Somar o peso de todas as perguntas do grupo
    let weightSum = questionGroup.questions.reduce((acc, curr) => {
      acc += curr.weight || 0;
      return acc;
    }, 0);

    // Arredondar o peso total para 2 casas decimais
    weightSum = Math.round(weightSum * 100) / 100;
  
    return weightSum;
  }

  // Verificar - alterar message para traduzir
  weightSumGreaterThan100(weightSum) {
    const message = 'Não é possível adicionar este grupo, pois excede 100% do peso.'

    if (weightSum > 100) {
      this.questionGroupFormModal.display = false;

      this.message.error(message);
      console.error(message)

      return true;
    }

    return false;
  }

  // Safe - NT
  acceptDeleteQuestionGroup() {
    this.question_groups.splice(this.groupIndex, 1);
    this.groupIndex = null;

    this.saveGroup.emit(this.question_groups);
  }

  // Safe - NT
  rejectDeleteQuestionGroup() {
    this.groupIndex = null;
  }

  // Verificar
  deleteQuestionGroup(questionGroup: QuestionGroupModel) {
    this.getIndex(questionGroup);
    this.confirm.key = 'question-group';
    this.confirm.confirm();
  }

  // Verificar - validar
  saveAttachments(e) {
    this.activeQuestionGroup.attachment = e[0];
    this.question_groups[this.groupIndex] = this.activeQuestionGroup;
    this.saveGroup.emit(this.question_groups);
  }

  // Verificar - validar
  onCloseAttachment = () => {
    this.activeQuestionGroup = null;
    this.groupIndex = null;
    this.questionGroupAttachmentModal.display = false;
    this.displayAttach = false;
  };

  // Verificar
  onOpenAttachmentModal = (question_group, index?: number) => {
    this.displayAttach = true;
    this.questionGroupAttachmentModal.display = true;

    this.activeQuestionGroup = question_group;
    this.questionGroupAttachmentModal.question_group_attachments = question_group.attachment ? [question_group.attachment] : [];
    this.questionGroupAttachmentModal.question_group_name = question_group.name;
    this.questionGroupAttachmentModal.onHide = this.onCloseAttachment;

    // this.getIndex(question_group);
    this.getIndexNew(question_group, index);
  };

  // Safe - Fixed Group Edit Bug and New Group Loss
  openQuestionGroupFormModal(questionGroup?: QuestionGroupModel, index?: number) {
    // Required to save new groups
    this.previousGroup = null;

    // Disable item_order for new item (bugfix)
    this.questionGroupFormModal.editing = false;

    if (questionGroup) {
      // this.getIndex(questionGroup);
      this.getIndexNew(questionGroup, index);
      this.questionGroupFormModal.editing = true;
      this.previousGroup = { ...questionGroup } as QuestionGroupModel;
      this.questionGroupFormModal.questionGroup = questionGroup;
      this.questionGroupFormModal.orderLimit = this.question_groups.length;
    } else {
      this.questionGroupFormModal.questionGroup.item_order = this.question_groups.length + 1;
      // this.questionIndex = null;
      // this.headerItemModal.headerItem.itemOrder = this.headerItems.length + 1
      this.questionGroupFormModal.orderLimit = this.question_groups.length + 1;
    }

    this.questionGroupFormModal.display = true;
  }

  orderQuestionGroup(e) {
    let message = "";

    // Validar se é um objeto válido com a propriedade 'item_order'
    if (
      typeof e !== 'object' || e == null ||
      typeof e.item_order !== 'number' ||
      isNaN(parseInt(e.item_order))
    ) {
      message = "problema na ordenação";
      this.message.error(message);
      console.error(message);
      return;
    }

    const maxItemOrder = this.question_groups.length + 1;

    // Validar se 'e.item_order' é um número válido dentro dos limites
    if (e.item_order <= 0 || e.item_order > maxItemOrder) {
      message = `'item_order' (${e.item_order}) deve ser um número válido, entre 1 e ${maxItemOrder}.`;
      this.message.error(message);
      console.error(message);
      return;
    }
  
    if (e.item_order > this.question_groups.length && !this.previousGroup) {
      this.question_groups.push(e);
    } else if (this.previousGroup) {
      if (this.previousGroup.item_order !== e.item_order) {
        this.question_groups = this.question_groups.map((group) => {
          if (group.item_order === e.item_order) {
            return e;
          } else if (
            this.previousGroup.item_order < e.item_order &&
            group.item_order > this.previousGroup.item_order &&
            group.item_order <= e.item_order
          ) {
            return { ...group, item_order: group.item_order - 1 };
          } else if (
            this.previousGroup.item_order > e.item_order &&
            group.item_order >= e.item_order &&
            group.item_order < this.previousGroup.item_order
          ) {
            return { ...group, item_order: group.item_order + 1 };
          } else {
            return group;
          }
        });
      }
    } else {
      this.question_groups = this.question_groups.map((group) => {
        if (group.item_order >= e.item_order) {
          return { ...group, item_order: group.item_order + 1 };
        } else {
          return group;
        }
      });

      // Se for nova e não edição, ira adicionar
      this.question_groups.push(e);
    }

    this.question_groups = _.orderBy(this.question_groups, 'item_order');

    this.groupIndex = null;
    this.previousGroup = null;

    this.saveGroup.emit(this.question_groups);
  }

  // Fixing Bugs: Ordenation, Duplication and Data Loss
  orderQuestionGroupNew(e) {
    let message = "";

    // Validar se é um objeto válido com a propriedade 'item_order'
    if (
      typeof e !== 'object' || e == null ||
      typeof e.item_order !== 'number' ||
      isNaN(parseInt(e.item_order))
    ) {
      message = "problema na ordenação";
      this.message.error(message);
      console.error(message);
      return;
    }

    const maxItemOrder = this.question_groups.length + 1;

    // Validar se 'e.item_order' é um número válido dentro dos limites
    if (e.item_order <= 0 || e.item_order > maxItemOrder) {
      message = `'item_order' (${e.item_order}) deve ser um número válido, entre 1 e ${maxItemOrder}.`;
      this.message.error(message);
      console.error(message);
      return;
    }

    this.updateAndReorderGroups(e, this.previousGroup, this.question_groups);

    this.question_groups = _.orderBy(this.question_groups, 'item_order');

    // reajusta de acordo com a posição
    // para corrigir item_order > length
    this.question_groups.forEach((_, i) => {
      this.question_groups[i].item_order = i + 1;
    });

    // Depois das alterações, salva elas no lugar certo (bugfix)
    this.saveGroup.emit(this.question_groups);
  }

  // O jeito na qual criaram essa edição de grupos e ordenação, é uma merda.
  // Por isso tive que criar esse metodo auxiliar, para corrigir os problemas dos outros
  updateAndReorderGroups(e, previousGroup, question_groups) {
    // Se e.item_order está fora dos limites e previousGroup não existe, adiciona o novo item
    if (e.item_order > question_groups.length && !previousGroup) {
      question_groups.push(e);
    } else if (previousGroup) {
      // Primeiro, corrige duplicidades e ajusta a lista
      const correctedGroups = [];

      // Itera sobre a lista para ajustar os item_order
      question_groups.forEach(item => {
        if (item.item_order === previousGroup.item_order) {
          // Substitui o item_order do item com o item_order do previousGroup
          correctedGroups.push({ ...item, item_order: previousGroup.item_order });
        } else {
          correctedGroups.push(item);
        }
      });

      // Adiciona o novo item com o item_order atualizado
      correctedGroups.push(e);

      // Ordena a lista com base no item_order
      correctedGroups.sort((a, b) => a.item_order - b.item_order);

      // Atualiza item_order para refletir a nova posição
      correctedGroups.forEach((item, index) => {
        item.item_order = index + 1;
      });

      // Atualiza question_groups com a lista corrigida
      question_groups = correctedGroups;
    }

    return question_groups;
  }

  selectGroup(e) {
    if (e.data) this.getIndex(e.data);
    else console.warn("'selectGroup' doesn't have data");
  }

  getIndexNew(data, index?: number) {
    this.groupIndex = (index || index == 0) ? index : this.question_groups.indexOf(data);

    if (this.groupIndex == null || this.groupIndex == -1) {
      console.warn("index Not Found in 'getIndex'", data);
    }
  }

  getIndex(data) {
    this.groupIndex = this.question_groups.indexOf(data);

    if (this.groupIndex == null || this.groupIndex == -1) {
      console.warn("index Not Found in 'getIndex'", data);
    }
  }

  // Verificar - NT
  saveQuestions(questions) {
    this.question_groups[this.groupIndex].questions = questions;
    this.saveGroup.emit(this.question_groups);
  }

  tCap = (key: string) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);
  translate = (key: string) => this.translateService.instant(key || 'invalid');
  tUpper = (key: string) => this.translate(key).toString().toUpperCase();

  // LEGACY

  //   openAttachmentModal(question) {
  //     this.displayAttach = true;
  //     this.questionGroupAttachmentModal.display = true;
  //     this.questionGroupAttachmentModal = question;
  //     this.questionGroupAttachmentModal.question_group_attachments =
  //       question.attachment ? [question.attachment] : [];
  //     this.questionGroupAttachmentModal.question_group_name =
  //       question.description;
  //     this.questionGroupAttachmentModal.onHide = this.onCloseAttachment;
  //     this.getIndex(question);
  //   }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/question-group/question-group.component.ts